import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_DEFINEXML_LANG: {
  PREVIEW_HTML_VERB: MvnCodeFE;

  PLACEHOLDER_AUTOMATION_VERB: MvnCodeFE;
  PLACEHOLDER_SELECTION_VERB: MvnCodeFE;
  PLACEHOLDER_METADATA_NAME_VERB: MvnCodeFE;
  PLACEHOLDER_DESCRIPTION_VERB: MvnCodeFE;
  PLACEHOLDER_DICTIONARY_NAME_VERB: MvnCodeFE;
  PLACEHOLDER_VERSION_VERB: MvnCodeFE;
  PLACEHOLDER_HREF_VERB: MvnCodeFE;
  PLACEHOLDER_STANDARD_VERSION_VERB: MvnCodeFE;
  PLACEHOLDER_FORMAT_VERB: MvnCodeFE;
  PLACEHOLDER_NUMERIC_VERB: MvnCodeFE;
  PLACEHOLDER_PAGE_NUMBER_VERB: MvnCodeFE;
  PLACEHOLDER_PREDECESSOR_VERB: MvnCodeFE;
  PLACEHOLDER_WHERE_CLAUSE_VERB: MvnCodeFE;
  PLACEHOLDER_LABEL_VERB: MvnCodeFE;
  PLACEHOLDER_METHOD_NAME_VERB: MvnCodeFE;
  PLACEHOLDER_METHOD_DESCRIPTION_VERB: MvnCodeFE;
  PLACEHOLDER_METHOD_CONTEXT_VERB: MvnCodeFE;
  PLACEHOLDER_METHOD_CODE_VERB: MvnCodeFE;
  PLACEHOLDER_COMMENT_VERB: MvnCodeFE;
  PLACEHOLDER_DOCUMENT_TITLE_VERB: MvnCodeFE;

  DELETE_DEFINEXML_ROW_SUCCEED: MvnCodeFE;
  DELETE_DEFINEXML_ROW_FAIL: MvnCodeFE;
  RESET_DEFINEXML_ROW_SUCCEED: MvnCodeFE;
  RESET_DEFINEXML_ROW_FAIL: MvnCodeFE;
  SAVE_DEFINEXML_ROW_SUCCEED: MvnCodeFE;
  SAVE_DEFINEXML_ROW_FAIL: MvnCodeFE;
  SAVE_DEFINEXML_ROW_FAIL_ON_DUPLICATED: MvnCodeFE;

  ADDABLE_EMPTY_DATA_DESCRIPTION: MvnCodeFE;
  ROW_CONTENT_RESET_DESCRIPTION: MvnCodeFE;

  APPLY_ALL_VARIABLES_DESCRIPTION: MvnCodeFE;
  APPLY_ALL_VARIABLES_CONFIRM_DESCRIPTION: MvnCodeFE;

  EXTERNAL_DICTIONARY_TAB_LABEL: MvnCodeFE;
  INTERNAL_CODELIST_TAB_LABEL: MvnCodeFE;

  VIEW_ALL_CODELIST_LABEL: MvnCodeFE;
  SEARCH_CODELIST_PLACEHOLDER: MvnCodeFE;
  SEARCH_NO_RESULTS: MvnCodeFE;
  CODELIST_CUSTOM_MAPPED_WARNING: MvnCodeFE;
  VLM_MAPPING_WILL_CLEAR_VARIABLE: MvnCodeFE;
  VLM_HAS_EXISTING_MAPPING_TOOLTIP: MvnCodeFE;
  CODELIST_VLM_MAPPED_BLOCK_ERROR: MvnCodeFE;

  METADATA_NAME_FORMAT_ERROR: MvnCodeFE;
  METADATA_NAME_DUPLICATE_ERROR: MvnCodeFE;
  METADATA_NAME_MAX_LENGTH: MvnCodeFE;
  METADATA_NAME_REQUIRED_ERROR: MvnCodeFE;

  DOCUMENT_FILE_TYPE_INVALID: MvnCodeFE;
  DOCUMENT_FILE_SIZE_EXCEEDED: MvnCodeFE;

  METHOD_SAVE_SUCCEED: MvnCodeFE;
  METHOD_SAVE_FAIL: MvnCodeFE;
  COMMENT_SAVE_SUCCEED: MvnCodeFE;
  COMMENT_SAVE_FAIL: MvnCodeFE;
  EXPRESSION_MAX_LIMIT: MvnCodeFE;
  EXPRESSION_PARTIAL_INPUT_FAIL: MvnCodeFE;
  CHAR_LIMIT_EXCEEDED: MvnCodeFE;
  METHOD_EDIT_TITLE: MvnCodeFE;
  METHOD_EDIT_DIALOG_TITLE: MvnCodeFE;
  METHOD_EDIT_TARGET_VARIABLE_LABEL: MvnCodeFE;
  METHOD_EDIT_WHERE_CLAUSE_LABEL: MvnCodeFE;
  METHOD_EDIT_DERIVATION_HISTORY_LABEL: MvnCodeFE;
  METHOD_DERIVATION_HISTORY_HEADER_ORDINAL: MvnCodeFE;
  METHOD_DERIVATION_HISTORY_HEADER_FORMULA: MvnCodeFE;
  METHOD_DERIVATION_HISTORY_HEADER_NODE: MvnCodeFE;
  METHOD_DESCRIPTION_LABEL: MvnCodeFE;
  METHOD_NAME_LABEL: MvnCodeFE;
  METHOD_TYPE_LABEL: MvnCodeFE;
  METHOD_LIST_TITLE: MvnCodeFE;
  METHOD_DESCRIPTION_PLACEHOLDER: MvnCodeFE;
  EXPRESSION_ADD_BUTTON: MvnCodeFE;
  EXPRESSION_CONTEXT_PLACEHOLDER: MvnCodeFE;
  EXPRESSION_CODE_PLACEHOLDER: MvnCodeFE;
  COMMENT_EDIT_TITLE: MvnCodeFE;
  COMMENT_LIST_TITLE: MvnCodeFE;
  COMMENT_EDITOR_PLACEHOLDER: MvnCodeFE;
  COMMENT_DESCRIPTION_PLACEHOLDER: MvnCodeFE;
  COMMENT_SEARCH_PLACEHOLDER: MvnCodeFE;
  METHOD_COPY_BUTTON: MvnCodeFE;
  PAGES_PLACEHOLDER: MvnCodeFE;
} = {
  PREVIEW_HTML_VERB: {
    ko: "HTML 미리보기",
    en: "HTML Preview",
  },
  PLACEHOLDER_AUTOMATION_VERB: {
    ko: "자동 입력",
    en: "Automation",
  },
  PLACEHOLDER_SELECTION_VERB: {
    ko: "선택",
    en: "Select....",
  },
  PLACEHOLDER_METADATA_NAME_VERB: {
    ko: "메타데이터 이름 입력",
    en: "Enter the metadata name",
  },
  PLACEHOLDER_DESCRIPTION_VERB: {
    ko: "기타 설명 입력",
    en: "Enter the description",
  },
  PLACEHOLDER_DICTIONARY_NAME_VERB: {
    ko: "예: MedDRA for Medical History",
    en: "e.g. MedDRA for Medical History",
  },
  PLACEHOLDER_VERSION_VERB: {
    ko: "버전 입력",
    en: "Enter the version",
  },
  PLACEHOLDER_HREF_VERB: {
    ko: "관련사이트 URL 입력",
    en: "Enter related site URL",
  },
  PLACEHOLDER_STANDARD_VERSION_VERB: {
    ko: "버전 입력(예: SDTMIG v.3.4)",
    en: "Enter the standard and version(e.g. SDTMIG v3.4)",
  },
  PLACEHOLDER_FORMAT_VERB: {
    ko: "데이터 출력 형식 입력(예: Z2.)",
    en: "Enter the display format(e.g. Z2.)",
  },
  PLACEHOLDER_NUMERIC_VERB: {
    ko: "숫자 입력",
    en: "Number only",
  },
  PLACEHOLDER_PAGE_NUMBER_VERB: {
    ko: "페이지 번호 입력(컴마로 구분)",
    en: "Enter pages separated by commas",
  },
  PLACEHOLDER_PREDECESSOR_VERB: {
    ko: "선행 Variable Name",
    en: "Enter the Predecessor",
  },
  PLACEHOLDER_WHERE_CLAUSE_VERB: {
    ko: "Where 조건절 입력",
    en: "Enter the Where Clause",
  },
  PLACEHOLDER_LABEL_VERB: {
    ko: "VLM에 대한 설명(또는 레이블) 입력",
    en: "Enter a description for the VLM",
  },
  PLACEHOLDER_METHOD_NAME_VERB: {
    ko: "Method 이름 입력",
    en: "Enter the Method name",
  },
  PLACEHOLDER_METHOD_DESCRIPTION_VERB: {
    ko: "Method 내용 입력",
    en: "Enter the description",
  },
  PLACEHOLDER_METHOD_CONTEXT_VERB: {
    ko: "Method 추가 설명 입력",
    en: "Enter the child Description",
  },
  PLACEHOLDER_METHOD_CODE_VERB: {
    ko: "코드화된 계산식 입력",
    en: "Enter the coded expression",
  },
  PLACEHOLDER_COMMENT_VERB: {
    ko: "Comment 입력",
    en: "Enter comment content",
  },
  PLACEHOLDER_DOCUMENT_TITLE_VERB: {
    ko: "문서명 입력",
    en: "Enter the document title",
  },
  DELETE_DEFINEXML_ROW_SUCCEED: {
    ko: "삭제했습니다.",
    en: "Deletion has been completed.",
  },
  RESET_DEFINEXML_ROW_SUCCEED: {
    ko: "사용자 입력 데이터가 초기화 되었습니다.",
    en: "User input data has been initialized.",
  },
  RESET_DEFINEXML_ROW_FAIL: {
    ko: "사용자 입력 데이터 초기화에 실패했습니다.",
    en: "Failed to initialize user input data.",
  },
  DELETE_DEFINEXML_ROW_FAIL: {
    ko: "삭제에 실패했습니다.",
    en: "Failed to delete.",
  },

  SAVE_DEFINEXML_ROW_SUCCEED: {
    ko: "저장했습니다.",
    en: "Saving has been completed.",
  },
  SAVE_DEFINEXML_ROW_FAIL: {
    ko: "저장에 실패했습니다.",
    en: "Failed to save.",
  },
  SAVE_DEFINEXML_ROW_FAIL_ON_DUPLICATED: {
    ko: "중복행이 존재합니다.",
    en: "Duplicate rows exist.",
  },
  ADDABLE_EMPTY_DATA_DESCRIPTION: {
    ko: "버튼을 눌러 빈 행을 추가하세요.",
    en: "Press the button to add a record.",
  },
  ROW_CONTENT_RESET_DESCRIPTION: {
    ko: "기본 할당된 정보 외에 사용자가 입력한 내용이 초기화 됩니다.",
    en: "User-entered content will be reset except for the default assigned information.",
  },
  APPLY_ALL_VARIABLES_DESCRIPTION: {
    ko: "동일 이름의 변수에 전체 적용",
    en: "Apply to all variables with the same name",
  },
  APPLY_ALL_VARIABLES_CONFIRM_DESCRIPTION: {
    ko: "’전체 적용’이 선택되어 중복 이름을 가진 {sameVariableNamesCount}개의 변수에 동일하게 적용됩니다.",
    en: "’Apply to all’ is selected, so the same setting will be applied to {sameVariableNamesCount} variables with duplicate names.",
  },
  EXTERNAL_DICTIONARY_TAB_LABEL: {
    ko: "External Dictionary",
    en: "External Dictionary",
  },
  INTERNAL_CODELIST_TAB_LABEL: {
    ko: "Internal Codelist",
    en: "Internal Codelist",
  },
  VIEW_ALL_CODELIST_LABEL: {
    ko: "전체 용어",
    en: "View all",
  },
  SEARCH_CODELIST_PLACEHOLDER: {
    ko: "Codelist 검색",
    en: "Search Codelist",
  },
  SEARCH_NO_RESULTS: {
    ko: "검색 결과가 없습니다.",
    en: "No results found.",
  },
  CODELIST_CUSTOM_MAPPED_WARNING: {
    ko: "SDTMIG 규정 외 Codelist가 매핑되었습니다.",
    en: "A codelist outside the SDTMIG specification has been mapped.",
  },
  VLM_MAPPING_WILL_CLEAR_VARIABLE: {
    ko: "{variableName}에 {codeName}(이)가 매핑되어 있습니다.\n이 작업을 수행하면 해당 매핑이 삭제됩니다.",
    en: "{codeName} is currently mapped to {variableName}.\nThis action will remove the existing mapping.",
  },
  VLM_HAS_EXISTING_MAPPING_TOOLTIP: {
    ko: "VLM에 이미 매핑된 항목이 있습니다.",
    en: "There is an existing mapping in VLM.",
  },
  CODELIST_VLM_MAPPED_BLOCK_ERROR: {
    ko: "VLM에 매핑된 항목이 있어 Variables 탭에서 매핑할 수 없습니다.",
    en: "Failed to map in the Variables tab because a mapping already exists in the VLM.",
  },
  METADATA_NAME_FORMAT_ERROR: {
    ko: "영숫자, 하이픈(-), 언더스코어(_)만 사용 가능합니다.",
    en: "Only alphanumeric characters, hyphens(-), and underscores(_) are allowed.",
  },
  METADATA_NAME_DUPLICATE_ERROR: {
    ko: "중복된 MetaData Name이 존재합니다.",
    en: "Duplicate metadata name exists.",
  },
  METADATA_NAME_MAX_LENGTH: {
    ko: "최대 {maxLength}자까지 입력 가능합니다.",
    en: "Maximum {maxLength} characters are allowed.",
  },
  METADATA_NAME_REQUIRED_ERROR: {
    ko: "필수 입력값입니다.",
    en: "This field is required.",
  },

  DOCUMENT_FILE_TYPE_INVALID: {
    ko: "지원하지 않는 파일 형식입니다. PDF 파일을 업로드해 주세요.",
    en: "Unsupported file format. Please upload a PDF file.",
  },
  DOCUMENT_FILE_SIZE_EXCEEDED: {
    ko: "파일 크기가 너무 큽니다. 50MB 이하의 PDF 파일을 업로드해 주세요. (현재 크기: {value})",
    en: "File size is too large. Please upload a PDF file smaller than 50MB. (Current size: {value})",
  },

  METHOD_SAVE_SUCCEED: {
    ko: "Method가 저장되었습니다.",
    en: "Method has been saved.",
  },
  METHOD_SAVE_FAIL: {
    ko: "Method 저장에 실패했습니다.",
    en: "Failed to save method.",
  },
  COMMENT_SAVE_SUCCEED: {
    ko: "Comment가 저장되었습니다.",
    en: "Comment has been saved.",
  },
  COMMENT_SAVE_FAIL: {
    ko: "Comment 저장에 실패했습니다.",
    en: "Failed to save comment.",
  },
  EXPRESSION_MAX_LIMIT: {
    ko: "Expression은 최대 {maxCount}개까지 추가할 수 있습니다.",
    en: "Failed to add. Maximum of {maxCount} expressions allowed.",
  },
  EXPRESSION_PARTIAL_INPUT_FAIL: {
    ko: "Program과 Code는 함께 입력하거나 모두 비워야 합니다.",
    en: "Failed to save: Program and Code must be entered together or both left empty.",
  },
  CHAR_LIMIT_EXCEEDED: {
    ko: "입력 가능한 글자 수를 초과했습니다. (최대 {maxLength}자)",
    en: "Character limit exceeded. (Max {maxLength})",
  },
  METHOD_EDIT_TITLE: {
    ko: "Method 편집",
    en: "Edit Method",
  },
  METHOD_EDIT_DIALOG_TITLE: {
    ko: "Method 편집 모달",
    en: "Edit Method Modal",
  },
  METHOD_EDIT_TARGET_VARIABLE_LABEL: {
    ko: "적용 대상 변수",
    en: "Target Variable",
  },
  METHOD_EDIT_WHERE_CLAUSE_LABEL: {
    ko: "Where Clause",
    en: "Where Clause",
  },
  METHOD_EDIT_DERIVATION_HISTORY_LABEL: {
    ko: "파생변수식 이력",
    en: "Derivation History",
  },
  METHOD_DERIVATION_HISTORY_HEADER_ORDINAL: {
    ko: "순서",
    en: "#",
  },
  METHOD_DERIVATION_HISTORY_HEADER_FORMULA: {
    ko: "Derivation formular",
    en: "Derivation formular",
  },
  METHOD_DERIVATION_HISTORY_HEADER_NODE: {
    ko: "노드명",
    en: "Node",
  },
  METHOD_DESCRIPTION_LABEL: {
    ko: "Method Description",
    en: "Method Description",
  },
  METHOD_NAME_LABEL: {
    ko: "Method 이름",
    en: "Method Name",
  },
  METHOD_TYPE_LABEL: {
    ko: "Type",
    en: "Type",
  },
  METHOD_LIST_TITLE: {
    ko: "Methods 목록",
    en: "Methods List",
  },
  METHOD_DESCRIPTION_PLACEHOLDER: {
    ko: "Method에 대한 설명과 적용한 계산식을 입력하세요.",
    en: "Enter method description and calculation formula",
  },
  EXPRESSION_ADD_BUTTON: {
    ko: "Expression 추가",
    en: "Add Expression",
  },
  EXPRESSION_CONTEXT_PLACEHOLDER: {
    ko: "Expression의 Context를 입력하세요.",
    en: "Enter context for the expression.",
  },
  EXPRESSION_CODE_PLACEHOLDER: {
    ko: "Expression의 Code를 입력하세요.",
    en: "Enter code for the expression.",
  },
  COMMENT_EDIT_TITLE: {
    ko: "Comment 편집",
    en: "Edit Comment",
  },
  COMMENT_LIST_TITLE: {
    ko: "Comments 목록",
    en: "Comments List",
  },
  COMMENT_EDITOR_PLACEHOLDER: {
    ko: "코멘트를 입력하세요 (최대 {maxLength}자)",
    en: "Enter comment (Max {maxLength} characters)",
  },
  COMMENT_DESCRIPTION_PLACEHOLDER: {
    ko: "코멘트 내용을 입력하세요.",
    en: "Enter comment description",
  },
  COMMENT_SEARCH_PLACEHOLDER: {
    ko: "Comment 검색",
    en: "Search Comment",
  },
  METHOD_COPY_BUTTON: {
    ko: "편집",
    en: "Copy",
  },
  PAGES_PLACEHOLDER: {
    ko: "1, 3, 5-7",
    en: "1, 3, 5-7",
  },
};

MvnCodeInitiate(CONVERTER_STUDY_DEFINEXML_LANG);
